<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="{{ entidade.nome }}"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            image-title="assets/img/global/exam.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/relatorios-personalizados']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <lib-export-list *ngIf="listDadosFormatado?.length > 0" (acao)="exportarListagem($event)"></lib-export-list>
          <button id="btnBuscarDados"
            (click)="buscarDados()" class="btn btn-success float-right mr-4" style="font-size: 13px">
            <i class="fa fa-play"></i>
            Executar Relatório
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 pt-2">
          <label style="font-weight: bold; color: #757575">
            {{login.orgao.codigo}} {{login.orgao.nome}}
          </label>
        </div>
      </div>
      <div class="row" *ngIf="entidade.descricao">
        <div class="col-md-12 pt-2">
          <label style="color: #757575">
            {{entidade.descricao}}
          </label>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <div class="row">
        <div class="col-md">
          <table class="table table-hover table-personalizado table-eddy" cellspacing="0">
            <thead>
              <tr *ngIf="camposSelecionados?.length > 0">
                <th [hidden]="col.agrupar" class="text-center" *ngFor="let col of camposSelecionados">
                  {{col.titulo}} <small class="text-secondary" style="display: block">({{col.subTitulo}})</small>
                </th>
              </tr>
            </thead>
            <tbody [innerHTML]="retornaConteudoTabela() | safeHtml">
            </tbody>
          </table>
        </div>
      </div>
      <div class="row" *ngIf="false">
        <div class="offset-6 col-6" style="text-align: right"
          *ngIf="listDadosFormatado && listDadosFormatado.length > 0">
          <span class="mr-1">{{paginaCorrente}} de</span>
          <span class="ml-1">{{paginaTotal}} </span>
          <a style="cursor: pointer" (click)="paginaAnterior()" aria-label="Previous" class="mr-3 ml-2">
            <img src="assets/img/comum/left-24.png" alt="anterior" height="20" width="20">
          </a>
          <a style="cursor: pointer" (click)="proximaPagina()" aria-label="Next" class="ml-1">
            <img src="assets/img/comum/right-24.png" alt="próximo" height="20" width="20">
          </a>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="modalOpcoesPdf" tabindex="-1" role="dialog" aria-labelledby="opcoesPdfModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title" id="opcoesPdfModalLabel">Opções do relatório em PDF</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h6>Selecione o tipo de orientação do relatório</h6>
              <div class="checkbox checbox-switch switch-info">
                <label>
                  <input [(ngModel)]="orientacao" [ngModelOptions]="{standalone: true}" type="checkbox" />
                  <span></span>
                  Imprimir em Paisagem
                </label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Fechar</button>
              <button type="button" class="btn btn-primary btn-sm" (click)="exportarListagem('pdf')">Imprimir</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modalFiltros" tabindex="-1" role="dialog" aria-labelledby="filtrosModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title" id="filtrosModalLabel">Relatório</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h6>Preencha os filtros do relatório para executá-lo</h6>
              <ul class="list-group" *ngIf="filtrosDinamicos?.length > 0">
                <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px 5px"
                  *ngFor="let filtro of filtrosDinamicos; let idx = index">
                  <div class="float-left">
                    <span class="font-weight-bold">{{ filtro.campo?.titulo }}</span>
                    <small class="text-secondary">&nbsp;({{ filtro.campo?.subTitulo }}):</small>
                    <span style="margin-left: 2px; display: block;">
                      {{ funcaoService.obterNomePorChave(listaOperadores, filtro.operador) }}
                    </span>
                  </div>
                  <div class="float-right">
                    <input *ngIf="filtro.campo && filtro.campo?.tipo === 'String'" [(ngModel)]="filtro.valorTemp"
                      [ngModelOptions]="{standalone: true}" type="text" class="form-control form-control-sm"
                      id="filtro_valor{{idx}}">
                    <input *ngIf="filtro.campo && filtro.campo?.tipo === 'Number'" [(ngModel)]="filtro.valorTemp"
                      [ngModelOptions]="{standalone: true}" type="text" class="form-control form-control-sm text-right"
                      id="filtro_valor{{idx}}" unmask="true" [imask]="imaskConfig">
                    <input *ngIf="filtro.campo && filtro.campo?.tipo === 'Date'" [(ngModel)]="filtro.valorTemp"
                      [ngModelOptions]="{standalone: true}" type="text" class="form-control form-control-sm"
                      id="filtro_valor{{idx}}" [unmask]="false" [imask]="{mask: '00/00/0000'}">
                    <div *ngIf="filtro.campo && filtro.campo?.tipo === 'Boolean'"
                      class="checkbox checbox-switch switch-primary">
                      <label>
                        <input [(ngModel)]="filtro.valorTemp" [ngModelOptions]="{standalone: true}" type="checkbox"
                          class="form-control form-control-sm" id="filtro_valor{{idx}}" />
                        <span></span>
                      </label>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button>
              <button type="button" class="btn btn-success btn-sm" (click)="buscarDados()">
                <i class="fa fa-play"></i> Executar Relatório
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- <pre>{{entidadeForm.get('url')?.value | json}}</pre> -->
  </div>
</div>